import { Inject, Injectable } from "@angular/core";
import { AuthService } from "admin/src/app/shared/services/auth.service";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { IRouteService } from "app/shared/model/route.model";
import { ServiceWorkerEvents } from "service-worker/service-events";
import { finalize } from "rxjs/operators";
import { ServiceWorkerService } from "service-worker/service-worker.service";
import { AppStateService } from "ng/src/app/core/services/app-state.service";
import { ILocationService } from "angular";
import { LogBookRootScopeService } from "app/shared/model/app.model";
import IInjectorService = angular.auto.IInjectorService;

@Injectable({
    providedIn: 'root'
})
export class AuthClientService extends AuthService {
    
    private _routeService?: IRouteService = undefined;
    
    get $routeService(): IRouteService {
        return this._routeService ??= this.$ajsInjector.get('$route') as IRouteService;
    }
    constructor(
        private serviceWorker: ServiceWorkerService,
        protected client: HttpClient,
        @Inject('$location') private $location: ILocationService,
        @Inject('$rootScope') private $rootScope: LogBookRootScopeService,
        @Inject('$injector') private $ajsInjector: IInjectorService
    ) {
        super(client);
        this.serviceWorker.registerForEvent(ServiceWorkerEvents.LOGOUT)
            .subscribe(() => {
                if (AppStateService.currentUser)
                    this.handleLogout(true);
            })
    }
    onUnauthenticated(response?: HttpErrorResponse) {
        let current = this.$routeService.current;
        if ((!response || response.status === 401) && !((current?.$$route as any)?.public ?? false)) //Cast as 'any' to prevent admin build issue
        {
            this.serviceWorker.sendEvent(ServiceWorkerEvents.LOGOUT);
            this.handleLogout(true);
        }
    }

    logout(redirectUrl: string = '/login') {

        // Disable beforeunload events that would prevent logout
        $(window).off('beforeunload');

        // Broadcast event that logout has successfully started
        this.$rootScope?.$broadcast('logoutSuccess');

        this.http.post('logout', {}, {
            headers: new HttpHeaders({
                'Accept': 'text/html'
            }),
            responseType: 'text',
        })
            .pipe(
                finalize(() => {
                    this.serviceWorker.sendEvent(ServiceWorkerEvents.LOGOUT);
                    window.location.href = '/#' + redirectUrl;
                    window.location.reload();
                })
            )
            .subscribe();
    }

    private handleLogout(sendRedirect = false) {
        this.$rootScope.$emit('$routeChangeError');
        this.$rootScope.user = undefined;
        this.$rootScope.selectedLog = undefined;
        this.$rootScope.authenticated = false;
        AppStateService.currentUser = undefined;

        if (sendRedirect)
            this.$rootScope.sendLoginRedirect(this.$location.path(), this.$location.search());

        setTimeout(() => {
            window?.location?.reload();
        })
    }
}